import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const StepDownICUConfinement = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex ?? 0, 0);

  const productCd = selectedProduct?.code ?? '';
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'step-down-icu-row-1'},
      items: [
        {
          key: propertyPaths.stepDownIntensiveCareUnitConfinementDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(
                propertyPaths.stepDownIntensiveCareUnitConfinementDetails.incurralPeriod
              )}
              disabled
              id={propertyPaths.stepDownIntensiveCareUnitConfinementDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(
                propertyPaths.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount
              )}
              disabled
              id={propertyPaths.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'step-down-icu-row-2'},
      items: [
        {
          key: propertyPaths.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.stepDownIntensiveCareUnitConfinementDetails.benefitAmount)
              )}
              id={propertyPaths.stepDownIntensiveCareUnitConfinementDetails.customizeBenefitAmount}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.stepDownIntensiveCareUnitConfinementDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Maximum Number of Days per Time Period"
              searchKey={`${productCd}StepDownIntensiveCareUnitConfinementBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(
                propertyPaths.stepDownIntensiveCareUnitConfinementDetails.maxBenefitNumber
              )}
              id={propertyPaths.stepDownIntensiveCareUnitConfinementDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'step-down-icu-row-3'},
      items: [
        {
          key: propertyPaths.stepDownIntensiveCareUnitConfinementDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period"
              disabled
              searchKey={`${productCd}StepDownIntensiveCareUnitConfinementBenefit.timePeriodCd`}
              value={getQuoteFieldValue<number>(propertyPaths.stepDownIntensiveCareUnitConfinementDetails.timePeriodCd)}
              id={propertyPaths.stepDownIntensiveCareUnitConfinementDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
